import { API_URL } from '@/http';

const DOWNLOAD_PATH = 'attachment/downloadByExternalId';

/**
 * Ссылка на вложение из ответа ChatAI — без access_token: текст ответа уходит в историю, буфер обмена
 * и обратно на сервер как контекст следующего вопроса. Скачивание идёт по Bearer (см. ChatMessageMarkdown).
 */
export function buildAttachmentDownloadHref(cardId: string, attachId: string, name: string): string {
    return `${API_URL}/${DOWNLOAD_PATH}/${cardId}/${attachId}/${encodeURIComponent(name)}`;
}

/**
 * Путь скачивания вложения от API_URL, если ссылка ведёт на наш downloadByExternalId, иначе null.
 * Чужой хост или лишние сегменты не принимаем: щелчок по такой ссылке ушёл бы в $api с Bearer.
 */
export function attachmentDownloadPath(href: string | undefined | null): string | null {
    if (!href) return null;
    const prefix = `${API_URL}/${DOWNLOAD_PATH}/`;
    const bare = href.split(/[?#]/, 1)[0];
    if (!bare.startsWith(prefix)) return null;

    const segments = bare.slice(prefix.length).split('/');
    if (segments.length !== 3) return null;
    for (const segment of segments) {
        let decoded: string;
        try {
            decoded = decodeURIComponent(segment);
        } catch {
            return null;
        }
        if (!decoded || decoded === '.' || decoded === '..') return null;
    }

    return `${DOWNLOAD_PATH}/${segments.join('/')}`;
}

const ACCESS_TOKEN_PARAM = /([?&])access_token=[^&#\s)\]"'<>]*(&?)/gi;

/**
 * Вырезает access_token из query ссылок в тексте. Старые ответы несли токен в ссылках, и модель
 * могла повторить такую ссылку из контекста — в DOM, копию и следующий запрос токен попасть не должен.
 */
export function stripAccessTokens(text: string): string {
    if (!text || !/access_token=/i.test(text)) return text;
    return text.replace(ACCESS_TOKEN_PARAM, (_match, separator: string, trailing: string) => {
        if (!trailing) return '';
        return separator;
    });
}
